import Rest from "../Base/Rest";

/**
 * @typedef {ContractsService}
 */
export default class ContractsService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = "/contracts";
	static attachmentsResource = "/contract-attachments";
	static movementsResource = "/contract-movements";

	getAttachments(gercon) {
		return this.get(`${this.constructor.attachmentsResource}?GERCON=${gercon}`);
	}

	addAttachment(data) {
		return this.post(this.constructor.attachmentsResource, data);
	}

	deleteAttachment(id) {
		return this.delete(`${this.constructor.attachmentsResource}/${id}`);
	}

	downloadAttachment(id) {
		return this.get(`${this.constructor.attachmentsResource}/download/${id}`);
	}

	getMovements(gercon) {
		return this.get(`${this.constructor.movementsResource}?GERCON=${gercon}`);
	}

	addMovement(data) {
		return this.post(this.constructor.movementsResource, data);
	}

	searchContractsByUser(userId) {
		return this.search({ CODUSU: userId});
	}
}
